export const MARKETO_FORMS_SCRIPT_ID = 'marketo-forms2-script'

export const injectMarketoForms = (baseUrl: string): Promise<void> =>
  new Promise((resolve, reject) => {
    if (window.MktoForms2) {
      resolve()
      return
    }

    // Remove the failed script so a later call can re-inject a fresh one instead
    // of finding a dead tag whose load/error events will never fire again.
    const rejectOnError = (element: Element) => () => {
      element.remove()
      reject(new Error('Failed to load Marketo forms2.js'))
    }

    const existingScript = document.getElementById(MARKETO_FORMS_SCRIPT_ID)
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(), { once: true })
      existingScript.addEventListener('error', rejectOnError(existingScript), {
        once: true,
      })
      return
    }

    const script = document.createElement('script')
    script.id = MARKETO_FORMS_SCRIPT_ID
    script.src = `${baseUrl}/js/forms2/js/forms2.min.js`
    script.async = true
    script.addEventListener('load', () => resolve(), { once: true })
    script.addEventListener('error', rejectOnError(script), { once: true })
    document.head.appendChild(script)
  })
